<template>
    <!-- Modal -->
    <div class="modal fade" id="workload-to-companies" tabindex="-1" aria-labelledby="workload-to-companies" aria-hidden="true" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Carga de trabalho Geral por empresa</h5>
                </div>
                <div class="modal-body">
                    <div class="modal-hours-company">
                        <div>
                            <span>Período</span>
                            <div class="row task-made-form">
                                <div class="form-group col-md-2">
                                    <date-picker
                                        v-model ="startDate"
                                        format="DD/MM/YY"
                                        v-mask="'##/##/##'"
                                        v-on:change="index"
                                    >
                                    </date-picker>
                                </div>
                                <div class="form-group col-md-2">
                                    <date-picker
                                        v-model ="endDate"
                                        format="DD/MM/YY"
                                        v-mask="'##/##/##'"
                                        v-on:change="index"
                                    >
                                    </date-picker>
                                </div>
                            </div>
                        </div>

                        <br />

                        <div v-if="loading" class="text-center loading-tasks"><i class="fas fa-spinner fa-pulse fa-3x fa-fw"></i></div>

                        <div v-else>
                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th>Empresa</th>
                                    <th>Horas</th>
                                    <th>%</th>
                                    <th class="text-center" width="150px"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="company in companies" :key="company.customer_id">
                                    <td>{{ company.customer_name }}</td>
                                    <td>{{ secondsToDate(company.total) }}</td>
                                    <td>{{ Math.abs(company.percentage).toFixed(2) }} %</td>
                                    <td>
                                        <div class="progress">
                                            <div class="progress-bar text-shadow" role="progressbar"
                                                 :style="'width:'+company.percentage+'%; background: green'"
                                            >
                                                {{ Math.abs(company.percentage).toFixed(2) }} %
                                            </div>

                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td>Total</td>
                                        <td>{{ secondsToDate(workload) }}</td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <hr />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" v-on:click="closeModal">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import $ from 'jquery'
    import DatePicker from 'vue2-datepicker'

    export default {
        name: 'WorkloadToCompaniesModal',
        inject: ['eventHub'],
        components: {
            DatePicker
        },
        data () {
            return {
                loading: false,
                companies: {},
                startDate: new Date(),
                endDate: new Date(),
                filters: {},
                stringFilters: '',
                workload: {}
            }
        },
        created () {
            this.eventHub.$on('workload-to-companies-modal', () => {
                this.clearData()
                this.index()
                $('#workload-to-companies').modal('show')
            })
        },
        methods: {
            clearData () {
                this.startDate = new Date()
                let firstDay = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), 1);
                this.startDate = firstDay
                this.endDate = new Date()
                this.filters = {}
                this.stringFilters= ''
                this.workload = ''
            },
            index () {
                this.stringFilters = 'startDate='
                    + this.formatDate(this.startDate)
                    + '&endDate=' + this.formatDate(this.endDate)
                this.loading = true
                axios
                    .get('/api/tasks_made/all-workload-companies?' + this.stringFilters)
                    .then((response) => {
                        this.companies = response.data
                        this.loading = false
                    })
                axios
                    .get('/api/tasks_made/all-workload?' + this.stringFilters)
                    .then((response) => {
                        this.workload = response.data
                    })
            },
            closeModal () {
                $('#workload-to-companies').modal('hide')
            },
            formatDate (date) {
                return (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2));
            },
            formatDateBr (date) {
                return (("0" + date.getDate()).slice(-2) + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + date.getFullYear());
            },
            secondsToDate (seconds) {
                if (isNaN(seconds)) {
                    return '00:00:00'
                }
                let hours = Math.floor(seconds / 3600)
                seconds %= 3600
                let minutes = Math.floor(seconds / 60)
                seconds = seconds % 60

                return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(Math.floor(seconds)).padStart(2, '0')
            },
        }
    }
</script>

<style scoped lang="sass">
    .modal-hours-company
        font-size: small
    .loading-tasks
        font-size: 50px
        margin-top: 200px

</style>
